import * as React from 'react';

// API
import apibridge from '../../apibridge';

// UTILS
import { validationErrorsToString } from '../../utils';

// PACKAGES
import { SwitchTransition, CSSTransition } from 'react-transition-group';

// COMPONENTS
import Button from '../../components/Button';
import LoadingSpinner from '../../components/LoadingSpinner';

// ICONS
import { ReactComponent as AlertIcon } from '../../assets/svg/alert.svg';

// TYPES
import { TrainingModuleDashboardTrainingModule } from '../../api/models';
import { closeModalType } from '../../components/GlobalModal';

interface RemoveModalTypes {
	getTrainingModulesData: () => Promise<void>;
	trainingModulesData: TrainingModuleDashboardTrainingModule[];
	setTrainingModulesData: React.Dispatch<React.SetStateAction<TrainingModuleDashboardTrainingModule[]>>;
	moduleId?: string;
	moduleTitle?: string;
	closeModal?: closeModalType;
}

const RemoveModal: React.FC<RemoveModalTypes> = ({
	closeModal,
	getTrainingModulesData,
	trainingModulesData,
	setTrainingModulesData,
	moduleId,
	moduleTitle
}) => {
	// Error and Loading state
	const [formErrorMessage, setFormErrorMessage] = React.useState<string>('');

	const [isLoading, setIsLoading] = React.useState<boolean>(false);

	const removeModule = async () => {
		setIsLoading(true);

		const newData = trainingModulesData.filter((item) => item.id !== moduleId);

		setTrainingModulesData(newData);

		const response = await apibridge.postTrainingModuleDelete({ id: moduleId });

		if (response.isError) {
			setIsLoading(false);

			setFormErrorMessage(
				response.validationErrors.length
					? validationErrorsToString(response.validationErrors)
					: response.message || 'An error has occurred'
			);
		} else {
			setIsLoading(false);

			if (closeModal) {
				closeModal();
			}

			getTrainingModulesData();
		}
	};

	return (
		<div className="modal-confirmation">
			{!!formErrorMessage ? (
				<div className="form-validation-error">{formErrorMessage}</div>
			) : (
				<SwitchTransition mode="out-in">
					<CSSTransition key={`key_${isLoading}`} timeout={600} classNames="standalone-fade" mountOnEnter unmountOnExit>
						{isLoading ? (
							<LoadingSpinner show={isLoading} />
						) : (
							<>
								<figure className="icon">
									<AlertIcon />
								</figure>

								<h2 className="heading h4">
									Are you sure you wish to remove <strong> '{moduleTitle}'?</strong>
								</h2>

								<section className="actions">
									<Button className="btn-primary full-width" onClick={removeModule}>
										Yes
									</Button>

									<Button className="btn-secondary full-width" onClick={closeModal}>
										Cancel
									</Button>
								</section>
							</>
						)}
					</CSSTransition>
				</SwitchTransition>
			)}
		</div>
	);
};

export default RemoveModal;
